import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Button } from 'semantic-ui-react';

import * as templateLib from 'libs/templateLib';
import * as attachLib from 'libs/attachLib';
import * as templateActions from 'modules/template';
import * as templateAttachActions from 'modules/templateAttach';

import { ExamTemplateEditModal } from 'components';

class CtExamTemplateAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onProgress: false,
      editModal: false,
      newTemplateNo: 0
    };
  }

  mountEditModal = () => {
    const { editModal } = this.state;

    if (editModal) {
      // 열려진 경우로 닫는다.
      this.setState({ editModal: false });
    } else {
      // 닫혀진 경우로 연다.
      this.addTemplate();
    }
  };

  addTemplate = async () => {
    const { attachData } = this.props;
    let respAttachData = {};
    if (attachData && Map.isMap(attachData)) {
      respAttachData = attachData.toJS();
    }

    let newTemplateNo = 0;
    try {
      const respObj = await templateLib.addTemplate();

      if (respObj && respObj.status && respObj.status === 200) {
        if (
          respObj.data &&
          Array.isArray(respObj.data.list) &&
          respObj.data.list.length > 0 &&
          respObj.data.list[0].templateNo
        ) {
          newTemplateNo = respObj.data.list[0].templateNo;
        } else {
          // 응답 데이터 오류
        }
      } else {
        // 응답 오류
      }
    } catch (e) {
      console.log(e);
    }

    const stateObj = { editModal: true };
    if (newTemplateNo) {
      stateObj.newTemplateNo = newTemplateNo;
    }
    this.setState(stateObj);
  };

  cancleAddTemplate = async () => {
    try {
      await templateLib.cancleAddTemplate({ examTemplateNo: this.state.newTemplateNo });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { onProgress, editModal, newTemplateNo } = this.state;
    const { isAuth } = this.props;
    const { mountEditModal, cancleAddTemplate } = this;

    const templateInfo = {
      templateNo: newTemplateNo,
      templateName: '',
      senderName: '',
      senderEmail: '',
      subject: '',
      body: '',
      attachType: '',
      attachName: '',
      attachCompressName: '',
      attachCompress: '',
      attachCompressPasswd: '',
      attachScreenType: 0,
      screenEnable: 1,
      linkAttach: '',
      linkText: '',
      examType: '',
      templatePublic: ''
    };

    return (
      <div>
        <Button
          className="bt-style-gleam common-button-brand"
          size="small"
          content={defineMessages(formatMessage({ id: 'CtExamTemplateAdd_1', defaultMessage: '등 록' }))}
          onClick={mountEditModal}
          color="blue"
        />
        {editModal && (
          <ExamTemplateEditModal
            addMode
            isAuth={isAuth}
            templateInfo={templateInfo}
            mountEditModal={mountEditModal}
            cancleAddTemplate={cancleAddTemplate}
          />
        )}
      </div>
    );
  }
}

CtExamTemplateAdd.propTypes = {};
CtExamTemplateAdd.defaultProps = {};

const mapStateToProps = (state, props) => {
  return {
    isAuth: state.user.get('isAuth'),
    attachData: state.templateAttach.get('data')
  };
};

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch),
  TemplateAttachActions: bindActionCreators(templateAttachActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtExamTemplateAdd));



// WEBPACK FOOTER //
// ./src/script/containers/admin/examTemplate/CtExamTemplateAdd.js